<template>
  <div class="component">
    <div class="component-title">预约订单取消规则</div>
    <div style="font-size: 12px;line-height: 28px;color: #85807B;">根据订单不同的运输状态所产生的实际运输成本不同，我们将对取消的订单收取部分费用</div>
    <div style="font-size: 12px;color: #FFBD2D;line-height: 12px;margin-bottom: 16px;">（除现在用车外的订单）</div>
    <table style="margin-bottom: 8px;font-size: 12px;">
      <tbody>
        <tr>
          <th width="30%">运输状态</th>
          <th colspan="2">取消成本</th>
        </tr>
        <tr>
          <td width="30%" style="font-size: 14px;">未接单</td>
          <td colspan="2" style="color:#EC892E;">免费取消</td>
        </tr>
        <tr>
          <td width="30%" rowspan="4">已接单未出发前取消（按起步价比例扣费）</td>
          <td>3小时内</td>
          <td>{{ carAttributeFeeConfig.customerAppointmentCancelOrderRule.ltThreeHour?carAttributeFeeConfig.customerAppointmentCancelOrderRule.ltThreeHour:'--' }}%</td>
        </tr>
        <tr>
          <td>3~6小时内</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenSixAndThreeHour?carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenSixAndThreeHour:'--'}}%</td>
        </tr>
        <tr>
          <td>6~12小时内</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenTwelveAndSixHour?carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenTwelveAndSixHour:'--'}}%</td>
        </tr>
        <tr>
          <td>12小时以上</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.gtTwelveHour?carAttributeFeeConfig.customerAppointmentCancelOrderRule.gtTwelveHour:'--'}}%</td>
        </tr>
        <tr>
          <td width="30%" rowspan="3">已出发到达提货地前取消</td>
          <td>5分钟内</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.ltFiveMinutes?carAttributeFeeConfig.customerAppointmentCancelOrderRule.ltFiveMinutes:'--'}}%</td>
        </tr>
        <tr>
          <td>5~10分钟内</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenFiveAndTenMinutes?carAttributeFeeConfig.customerAppointmentCancelOrderRule.betweenFiveAndTenMinutes:'--'}}%</td>
        </tr>
        <tr>
          <td>超过10分钟</td>
          <td>{{carAttributeFeeConfig.customerAppointmentCancelOrderRule.gtTenMinutes?carAttributeFeeConfig.customerAppointmentCancelOrderRule.gtTenMinutes:'--'}}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { $math } from "@/utils/math.js";

export default {
  name:"LoadingUnloadingFee",
  props:{
    carAttributeFeeConfig:{
      type:Object,
      default:()=>{
        return {
          appointmentOrderCancelTransportOrderRule:{},
        }
      }
    }
  },
  data(){
    return {
      bulkCargoFeeTypeOptions:{
        complete:"整车",
        half:"半车",
        none:"默认"
      },
      math:$math
    }
  }
}
</script>

<style scoped lang="scss">
.component {
  margin-top: 32px;
}
 table,
th,
td {
  border: 1px solid #C9C2BB;
}

table {
  width: 100%;
  margin: 0 auto;
  display: table;
  border-spacing: 0;
  border-radius: 4px;
  overflow: hidden;
}
th,
td {
  border-top-width: 0;
  border-left-width: 0;
  text-align: center;
}

th:last-child,
td:last-child {
  border-right-width: 0;
}

tr:last-child td {
  border-bottom-width: 0;
}

tr {
  height: 40px;
}
td tr td{
  border-top: 1px solid #C9C2BB;
}
td tr:first-child td {
  border-top: 0;
  border-bottom: 0;
}
table tbody > tr > th {
  background-color: #F8F8F8;
  color:#3D3833;
  font-weight: 500;
}
</style>